import React from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import Dashbooard from "./pages/Dashbooard";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import Management from "./pages/Management";
import Projects from "./pages/Projects";
import Units from "./pages/Units";
import Media from "./pages/Media";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Title from "./pages/Title";
import PermissionGroup from "./pages/PermissionGroup";
import Admins from "./pages/Admins";
import AddPermissiongroup from "./pages/AddPermissiongroup";
import NotificationsCenter from "./pages/NotificationsCenter";
import SendNotifications from "./pages/SendNotifications";
import AllUnits from "./pages/AllUnits";
import AddUnit from "./pages/AddUnit";
import Article from "./pages/Article";
import ProjectNews from "./pages/ProjectNews";
import Paid from "./pages/Paid";
import { Toaster } from "react-hot-toast";
import ForgetPassword from "./pages/ForgetPassword";
import { VerifyAccount } from "./pages/VerifyAccount";
import { ResetPassword } from "./pages/ResetPassword";
import PaymentMethod from "./pages/PaymentMethod";
import ChangePasssword from "./pages/ChangePassword";
import GlobalSettings from "./pages/GlobalSettings";
import Finance from "./pages/Finance";
import SellerFinance from "./pages/SellerFinance";
import AdminInstallmentOperations from "./pages/AdminInstallmentOperations";
import RegistrationReviews from "./pages/RegistrationReviews";
import Customers from "./pages/Customers";
import Merchants from "./pages/Merchants";

export default function App() {
  let routers = createBrowserRouter([
    {
      path: "",
      element: <Layout />,
      children: [
        {
          index: true,
          element: (
            <ProtectedRoute>
              <Dashbooard />
            </ProtectedRoute>
          ),
        },
        { path: "login", element: <Login /> },
        { path: "forgetPassword", element: <ForgetPassword /> },
        { path: "auth/verify/:token", element: <VerifyAccount /> },
        { path: "reset-password/:token", element: <ResetPassword /> },
        {
          path: "changepasssword",
          element: (
            <ProtectedRoute>
              <ChangePasssword />
            </ProtectedRoute>
          ),
        },
        {
          path: "management/team",
          element: (
            <ProtectedRoute>
              <Management />
            </ProtectedRoute>
          ),
        },
        {
          path: "globalSettings",
          element: (
            <ProtectedRoute>
              <GlobalSettings />
            </ProtectedRoute>
          ),
        },
        {
          path: "management/title",
          element: (
            <ProtectedRoute>
              <Title />
            </ProtectedRoute>
          ),
        },
        {
          path: "management/permissiongroup",
          element: (
            <ProtectedRoute>
              <PermissionGroup />
            </ProtectedRoute>
          ),
        },
        {
          path: "management/permissiongroup/addpermissiongroup",
          element: (
            <ProtectedRoute>
              <AddPermissiongroup />
            </ProtectedRoute>
          ),
        },
        {
          path: "management/admins",
          element: (
            <ProtectedRoute>
              <Admins />
            </ProtectedRoute>
          ),
        },
        {
          path: "projects/countriescities",
          element: (
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          ),
        },
        {
          path: "banner",
          element: (
            <ProtectedRoute>
              <Media />
            </ProtectedRoute>
          ),
        },
        {
          path: "customers",
          element: (
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          ),
        },
        { path: "users", element: <Navigate to="/customers" replace /> },
        {
          path: "category",
          element: (
            <ProtectedRoute>
              <Units />
            </ProtectedRoute>
          ),
        },
        {
          path: "units/allunits",
          element: (
            <ProtectedRoute>
              <AllUnits />
            </ProtectedRoute>
          ),
        },
        {
          path: "units/addunit",
          element: (
            <ProtectedRoute>
              <AddUnit />
            </ProtectedRoute>
          ),
        },
        {
          path: "merchants",
          element: (
            <ProtectedRoute>
              <Merchants />
            </ProtectedRoute>
          ),
        },
        { path: "seller", element: <Navigate to="/merchants" replace /> },
        {
          path: "media/banner",
          element: (
            <ProtectedRoute>
              <Media />
            </ProtectedRoute>
          ),
        },
        {
          path: "media/article",
          element: (
            <ProtectedRoute>
              <Article />
            </ProtectedRoute>
          ),
        },
        {
          path: "media/projectnews",
          element: (
            <ProtectedRoute>
              <ProjectNews />
            </ProtectedRoute>
          ),
        },
        {
          path: "finance",
          element: (
            <ProtectedRoute>
              <Finance />
            </ProtectedRoute>
          ),
        },
        {
          path: "installment-operations",
          element: (
            <ProtectedRoute>
              <AdminInstallmentOperations />
            </ProtectedRoute>
          ),
        },
        {
          path: "registration-reviews",
          element: (
            <ProtectedRoute>
              <RegistrationReviews />
            </ProtectedRoute>
          ),
        },
        {
          path: "finance/sellerFinance",
          element: (
            <ProtectedRoute>
              <SellerFinance />
            </ProtectedRoute>
          ),
        },
        {
          path: "financialstatement/paid",
          element: (
            <ProtectedRoute>
              <Paid />
            </ProtectedRoute>
          ),
        },
        {
          path: "paymentMethod",
          element: (
            <ProtectedRoute>
              <PaymentMethod />
            </ProtectedRoute>
          ),
        },
        {
          path: "notificationscenter",
          element: (
            <ProtectedRoute>
              <NotificationsCenter />
            </ProtectedRoute>
          ),
        },
        {
          path: "sendnotifications",
          element: (
            <ProtectedRoute>
              <SendNotifications />
            </ProtectedRoute>
          ),
        },
        {
          path: "*",
          element: (
            <ProtectedRoute>
              <NotFound />
            </ProtectedRoute>
          ),
        },
      ],
    },
  ]);

  return (
    <>
      <Toaster
        toastOptions={{
          style: {
            background: "#333",
            color: "#fff",
            fontSize: "16px",
            borderRadius: "20px",
          },
          success: {
            style: {
              background: "green",
            },
          },
          error: {
            style: {
              background: "red",
            },
          },
        }}
      />

      <RouterProvider router={routers}></RouterProvider>
    </>
  );
}
